export default {
  data () {
    return {
      // By default, the component hasn't been changed yet
      hasBeenChanged: false,
      // Define if socket.io is enabled
      enableSocketIO: process.env?.VUE_APP_SOCKET_ENABLED === 'yes',
      // The number of messages received
      messageCounter: 0
    }
  },
  methods: {
    /**
     * This method is called when the component is created and mounted, and it subscribes to the socket.io event
     */
    subscribe () {
      if (this.enableSocketIO && 'id' in this.value) {
        this.sockets.subscribe(`onDocument_${this.value.id}`, this.onMessageReceived)
      }
    },
    /**
     * This method is called when the component is unmounted and it unsubscribes from the socket.
     */
    unsubscribe () {
      // this.showReloadButton = false
      if (this.enableSocketIO && 'id' in this.value) {
        this.sockets.unsubscribe(`onDocument_${this.value.id}`)
      }
    },
    /**
     * This method is called when a new message is received from the socket.io event
     * and it updates the hasBeenChanged property to true
     * @param {*} event
     */
    onMessageReceived (event) {
      if (event.hasOwnProperty('id') && event.id) {
        this.hasBeenChanged = true
        this.messageCounter++
      }
    }
  },
  mounted () {
    // Call the subscribe method when the component is mounted to start listening for socket.io events
    this.subscribe()
  },
  beforeDestroy () {
    // Call the unsubscribe method when the component is destroyed to stop listening for socket.io events
    this.unsubscribe()
  }
}
